/** Determines whether a mouse is connected to the user device. */
export default function mouseExists(): boolean
{
    return !window.matchMedia(`(any-hover: none)`).matches;
}
